import merge from 'lodash/merge';
import pick from 'lodash/pick';

const baseModel = {
  roomId: undefined,
  roomTimerPauseDTOS: [],
  startDateTime: '',
  startPersonnelId: undefined,
  startTask : {},
  stopTaskId: undefined,
  stopPersonnelId: undefined,
  stopDateTime:'',
};

const pauseModel = {
  pauseDateTime: '',
  pausePersonnelId: undefined,
  unpauseDateTime: '',
  unpausePersonnelId: undefined,
  irregularity: {},
};

export class TimerModel {
  constructor(data) {
    merge(this, baseModel, pick(data, Object.keys(baseModel)));
  }
}

